export default [
  { key: 'Serial_number', title: 'Serial Number' },
  { key: 'last_Active', title: 'Last Active' },
  { key: 'version_no', title: 'Version' },
  { key: 'os_info', title: 'OS Info' },
  { key: 'gpu', title: 'GPU' },
  { key: 'ram', title: 'RAM' },
  { key: 'Organization', title: 'Organization' },
];
